/**
 * Distance unit values
 */
export enum DistanceUnitEnum {
	KM = 'km',
	MI = 'mi',
}
